import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import {
  DocumentProcessingJobWrapper,
  DocumentProcessingJobStatus,
} from "../model/DocumentProcessingJob";
import DocumentProcessingJobListApiRequest from "../request/DocumentProcessingJobListApiRequest";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const documentProcessingTransform = async (
  data: any
): Promise<DocumentProcessingJobWrapper> => {
  let newData = { count: 0, pages: 0, results: [] };

  // Handle non-paginated response (array) from pagination=false
  if (data && Array.isArray(data)) {
    const MS_IN_HOURS = 1000 * 60;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const results = data.map((item: any) => {
      const transformData = { ...item };
      if (
        item &&
        item.processing_sla_deadline &&
        item.status &&
        [
          DocumentProcessingJobStatus.UPLOADED,
          DocumentProcessingJobStatus.PROCESSING,
          DocumentProcessingJobStatus.PROCESSED,
          DocumentProcessingJobStatus.MATCHING,
        ].includes(item.status)
      ) {
        const dateThen = new Date(item.processing_sla_deadline);
        const dateNow = new Date();
        const utc1 = Date.UTC(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
        const utc2 = Date.UTC(dateThen.getFullYear(), dateThen.getMonth(), dateThen.getDate(), dateThen.getHours(), dateThen.getMinutes(), dateThen.getSeconds());
        transformData.processingETA = Math.ceil((utc2 - utc1) / MS_IN_HOURS);
      }
      return transformData;
    });
    return { count: results.length, pages: 1, results };
  }

  if (data && data.results) {
    const MS_IN_HOURS = 1000 * 60;
    newData = { ...data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newData.results = data.results.map((item: any) => {
      const transformData = { ...item };

      if (
        item &&
        item.processing_sla_deadline &&
        item.status &&
        [
          DocumentProcessingJobStatus.UPLOADED,
          DocumentProcessingJobStatus.PROCESSING,
          DocumentProcessingJobStatus.PROCESSED,
          DocumentProcessingJobStatus.MATCHING,
        ].includes(item.status)
      ) {
        const dateThen = new Date(item.processing_sla_deadline);
        const dateNow = new Date();
        const utc1 = Date.UTC(
          dateNow.getFullYear(),
          dateNow.getMonth(),
          dateNow.getDate(),
          dateNow.getHours(),
          dateNow.getMinutes(),
          dateNow.getSeconds()
        );
        const utc2 = Date.UTC(
          dateThen.getFullYear(),
          dateThen.getMonth(),
          dateThen.getDate(),
          dateThen.getHours(),
          dateThen.getMinutes(),
          dateThen.getSeconds()
        );

        transformData.processingETA = Math.ceil((utc2 - utc1) / MS_IN_HOURS);
      }
      return transformData;
    });
  }
  return newData;
};

const DocumentUploadListApiService = async (
  request: DocumentProcessingJobListApiRequest
): Promise<DocumentProcessingJobWrapper> => {
  const url = "/document_processing_jobs";
  const { data } = await axios.get(url, { params: request });

  return documentProcessingTransform(data);
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDocumentUploadListApiService = (
  request: DocumentProcessingJobListApiRequest
) =>
  useQuery<Record<string, DocumentProcessingJobWrapper>, AxiosError>(
    ["DocumentUploadListApiService", request.page, request.pagination, request.document_type],
    async () => {
      const response = await DocumentUploadListApiService(request);
      return {
        [request.document_type]: response, // Save the response data against the key defined by request.document_type
      };
    }
  );

export default useDocumentUploadListApiService;
